import { Component, Input } from '@angular/core';

import { Usuario } from '../../usuario';

@Component({
    selector: 'sgt-usuario-permissao-analise-mercado',
    templateUrl: './usuario-permissao-analise-mercado.component.html',
    styleUrls: ['./usuario-permissao-analise-mercado.component.less']
})
export class UsuarioPermissaoAnaliseMercadoComponent {
    @Input() entity: Usuario;

    /** Verifica se possui alguma opção para selecionar */
    possuiAlgumaOpcao(): boolean {
        return true;
    }
}
